const config = window.APP_CONFIG;

const emailTemplatesFR = [
  // 0. CEO Fraud
  {
    id: 0,
    language: "fr",
    subject: "Réponse rapide",
    body: `<p>Bonjour {{nickname}},</p>
      <p>Je suis actuellement en réunion et j’ai besoin que tu effectues rapidement une tâche pour moi. 
      Envoie-moi ton numéro WhatsApp et attends mon message.</p>
      <p class="pt-4">Bien à toi,</p><p>${config.CEO}</p>`,
    sender: `${config.CEO} <alainhenrard76@gmail.com>`,
    isPhishing: true,
    footer: ``
  },

  // 1. Sécurité – connexion suspecte
  {
    id: 1,
    language: "fr",
    subject: "Activité de connexion inhabituelle détectée",
    body: `
    <div style="text-align:center;">
      <img src="/images/microsoft.png" alt="Logo Microsoft" style="display:block; margin:0 auto; height:150px;" />
      <p style="font-size:15px; line-height:1.6; color:#333;">
        Nous avons remarqué une tentative de connexion à votre compte Microsoft depuis un nouvel appareil ou une nouvelle localisation.
      </p>
      <p style="font-size:15px; line-height:1.6; color:#333;">
        Nous vous recommandons de vérifier immédiatement les paramètres de votre compte.
      </p>
      <div style="margin:24px 0;">
        <a href="https://micr0s0ft.com/login" style="background:#dc3545;color:white;padding:12px 20px;border-radius:4px;text-decoration:none;font-weight:bold;">
          Vérifier l’activité
        </a>
      </div>
      <p style="font-size:13px; color:#666;">Activité détectée : 5 juin 2025 à 10h42 (CET)</p>
    </div>
  `,
    sender: "Microsoft Sécurité <security@micr0s0ft.com>",
    isPhishing: true,
    footer: `
    <div style="font-size:12px; color:#888; padding-top:10px; text-align:center;">
      Cet e-mail a été généré automatiquement. Ne répondez pas directement à ce message.<br />
      Consultez vos <a href="https://account.microsoft.com/security" style="color:#dc3545; text-decoration:underline;">paramètres de sécurité</a> pour plus d’informations.
    </div>
  `
  },

  // 2. Événement interne – inscription
  {
    id: 2,
    language: "fr",
    subject: "Invitation : teambuilding sur site – inscrivez-vous dès maintenant",
    body: `
    <div style="text-align:center;">
      <p style="font-size:15px; line-height:1.6; color:#333;">Bonjour {{nickname}},</p>
      <p style="font-size:15px; line-height:1.6; color:#333;">
        Les inscriptions sont ouvertes pour notre prochain événement de teambuilding.
      </p>
      <p style="font-size:15px; line-height:1.6; color:#333;">
        Nous avons hâte de passer une journée réussie ensemble !
      </p>
      <div style="margin:24px 0;">
        <a href="https://${config.companyDomain}/inschrijven" style="background:#007bff;color:white;padding:12px 20px;border-radius:4px;text-decoration:none;font-weight:bold;">
          Je m’inscris
        </a>
      </div>
    </div>
  `,
    sender: `Équipe Événementielle <events@${config.companyDomain}>`,
    isPhishing: false,
    footer: `
    <div style="font-size:12px; color:#888; padding-top:10px; text-align:center;">
      Cette invitation a été envoyée par l’équipe interne des événements.<br />
      Questions ? Contactez <a href="mailto:events@${config.companyDomain}" style="text-decoration:underline;color:#007bff;">events@${config.companyDomain}</a>
    </div>
  `
  },

  // 3. Fête de Noël
  {
    id: 3,
    language: "fr",
    subject: "🎄 Invitation : fête de Noël du bureau",
    body: `
    <div style="text-align:center;">
      <img src="/images/christmas.jpg" alt="Fête de Noël" style="display:block; margin:0 auto;height:150px;margin-bottom:12px;" />
      <p>Chers collègues,</p>
      <p style="font-size:15px;">🎅 Notre fête de Noël annuelle approche ! Serez-vous des nôtres ?</p>
      <p style="font-size:15px;">Inscrivez-vous ci-dessous pour confirmer votre présence.</p>
      <div style="margin:16px 0;">
        <a href="https://${config.companyDomain}/kerstfeest" style="background:#00aca9;color:white;padding:10px 16px;border-radius:4px;text-decoration:none;">Je participe</a>
      </div>
      </div>
  `,
    sender: `Service RH <hr@${config.companyDomain}>`,
    isPhishing: false,
    footer: `<div style="font-size:12px;color:#888;text-align:center;">
      Organisé par les RH. Merci de répondre avant le 15 décembre.
    </div>`
  },

  // 4. Informatique – mise à jour
  {
    id: 4,
    language: "fr",
    subject: "Mise à jour de sécurité importante – à effectuer aujourd’hui",
    body: `
    <div style="text-align:center;">
      <p style="font-size:15px; line-height:1.6; color:#333;">Bonjour {{nickname}},</p>
      <p style="font-size:15px; line-height:1.6; color:#333;">
        Une mise à jour de sécurité critique est disponible pour votre poste de travail. Afin de réduire les risques, merci de l’installer dès aujourd’hui.
      </p>
      <p style="font-size:15px; line-height:1.6; color:#333;">
        Cliquez sur le bouton ci-dessous pour lancer la mise à jour immédiatement.
      </p>
      <div style="margin:24px 0;">
        <a href="https://${config.companyDomainPhishing}/update" style="background:#ffc107;color:black;padding:12px 20px;border-radius:4px;text-decoration:none;font-weight:bold;">
          Démarrer la mise à jour
        </a>
      </div>
      <p style="font-size:13px; color:#666;">
        ID de mise à jour : KB509821 — disponible depuis ${new Date().toLocaleDateString('fr-FR')}
      </p>
    </div>
  `,
    sender: `Support IT <it@${config.companyDomainPhishing}>`,
    isPhishing: true,
    footer: `
    <div style="font-size:12px; color:#888; padding-top:10px; text-align:center;">
      Questions ? Contactez <a href="mailto:it@${config.companyDomainPhishing}" style="text-decoration:underline;color:#ffc107;">it@${config.companyDomainPhishing}</a><br />
      Ce message a été envoyé automatiquement par le système de gestion IT.
    </div>
  `
  },

  // 5. Notification de compte – nouvelle réponse
  {
    id: 5,
    language: "fr",
    subject: "Quelqu’un a répondu à votre publication",
    body: `
      <div style="text-align:center;">
        <img src="/images/linkedin.png" alt="LinkedIn" style="display:block;margin:0 auto;height:200px;" />
        <p style="font-size:15px; line-height:1.6;">Quelqu’un vient de commenter l’une de vos publications récentes.</p>
        <p style="font-size:15px; line-height:1.6;">Consultez le commentaire et participez à la conversation.</p>
        <div style="margin:20px 0;">
          <a href="https://www.Iinkedin/activity/post/8394" style="background:#0077b5;color:white;padding:10px 20px;border-radius:4px;text-decoration:none;display:inline-block;">Voir le commentaire</a>
        </div>
      </div>
  `,
    sender: "Notifications LinkedIn <noreply@Iinkedin.com>",
    isPhishing: true,
    footer: `<div style="font-size:12px;color:#888;padding-top:10px;text-align:center;">
      Vous recevez cette alerte selon vos paramètres de notification.<br />
      <a href="https://www.Iinkedin.com/settings/" style="color:#0077b5;text-decoration:underline;">Gérer mes paramètres</a>
    </div>`
  },

  // 6. HelloFresh
  {
    id: 6,
    language: "fr",
    subject: "Profitez de 10 € de réduction sur votre prochain panier HelloFresh",
    body: `
    <div style="text-align:center;">
      <img src="/images/HelloFresh.svg" alt="Logo HelloFresh" style="display:block; margin: 0 auto 16px; height:150px;" />
      <p style="font-size:15px; line-height:1.6; color:#333;">Cher client,</p>
      <p style="font-size:15px; line-height:1.6; color:#333;">
        En tant qu’utilisateur fidèle, nous souhaitons vous remercier avec une réduction personnelle de <strong>10 €</strong> sur votre prochain panier HelloFresh.
      </p>
      <p style="font-size:15px; line-height:1.6; color:#333;">Utilisez le bouton ci-dessous pour activer votre remise :</p>
      <div style="margin:20px 0;">
        <a href="https://hellofresh.be/activeren" style="background:#28a745;color:white;padding:12px 20px;border-radius:4px;text-decoration:none;font-weight:bold;">
          Activer ma remise
        </a>
      </div>
      <p style="font-size:13px; color:#666;">Code promo : <strong>HF-NOEL10</strong></p>
    </div>
  `,
    sender: "HelloFresh Belgique <info@hellofresh.be>",
    isPhishing: false,
    footer: `
    <div style="font-size:12px; color:#888; padding-top:10px; text-align:center;">
      Cette promotion est valable jusqu’au 31 décembre et réservée à certains utilisateurs.<br />
      Consultez les <a href="https://hellofresh.be/voorwaarden" style="color:#28a745; text-decoration:underline;">conditions générales</a> pour plus d’informations.
    </div>
  `
  },

  // 7. Réseaux sociaux – alerte Facebook
  {
    id: 7,
    language: "fr",
    subject: "Vous avez un nouveau commentaire sur votre publication",
    body: `
    <div style="text-align:center;">
      <img src="/images/fb.svg" alt="Logo Facebook" style="display:block; margin:0 auto 16px; height:40px;" />
      <p style="font-size:15px; color:#333; line-height:1.6;">
        Quelqu’un a commenté l’une de vos publications Facebook récentes.
      </p>
      <p style="font-size:15px; color:#333; line-height:1.6;">
        Consultez le commentaire et restez à jour dans la discussion.
      </p>
      <div style="margin:20px 0;">
        <a href="https://facebook-alerts.com/meldingen" style="background:#1877f2;color:white;padding:12px 20px;border-radius:4px;text-decoration:none;font-weight:bold;">
          Voir le commentaire
        </a>
      </div>
    </div>
  `,
    sender: "Notifications Facebook <no-reply@facebook-alerts.com>",
    isPhishing: true,
    footer: `
    <div style="font-size:12px; color:#888;padding-top:10px; text-align:center;">
      Cet e-mail a été envoyé à partir de vos paramètres de compte.<br />
      Facebook ne vous demandera jamais d’informations personnelles par e-mail.<br />
      <a href="https://facebook.com/settings/notifications" style="color:#1877f2;text-decoration:underline;">Gérer mes notifications</a>
    </div>
  `
  },

  // 8. Livraison – Bpost
  {
    id: 8,
    language: "fr",
    subject: "Votre livraison Bpost est prévue pour demain",
    body: `
    <div style="text-align:center;">
      <img src="/images/bpost.svg" alt="Logo Bpost" style="display:block; margin:0 auto 16px; height:100px;" />
      <p style="font-size:15px; line-height:1.6; color:#333;">
        Votre colis est en route et sera <strong>livré demain entre 09h00 et 13h00</strong>.
      </p>
      <p style="font-size:15px; line-height:1.6; color:#333;">
        Vous pouvez suivre votre envoi en direct via le bouton ci-dessous.
      </p>
      <div style="margin:20px 0;">
        <a href="https://track.bpost.be/pakket" style="background:#dc3545;color:white;padding:12px 20px;border-radius:4px;text-decoration:none;font-weight:bold;">
          Suivre mon colis
        </a>
      </div>
      <p style="font-size:13px; color:#666;">Numéro de suivi : 1ZA84XF993712736*</p>
    </div>
  `,
    sender: "Service Client Bpost <info@bpost.be>",
    isPhishing: false,
    footer: `
    <div style="font-size:12px; color:#888;text-align:center;">
      Vous pouvez suivre votre colis jusqu’à 7 jours après la livraison.<br />
      Questions ? Consultez notre <a href="https://bpost.be/hulp" style="color:#dc3545; text-decoration:underline;">service client</a>.
    </div>
  `
  },

  // 9. Énergie – facture Eneco
  {
    id: 9,
    language: "fr",
    subject: "Votre facture Eneco de ce mois est disponible",
    body: `
    <div style="text-align:center;">
      <img src="/images/Eneco.png" alt="Logo Eneco" style="display:block; margin:0 auto 16px; height:150px;" />
      <p style="font-size:15px; line-height:1.6; color:#333;">
        Votre nouvelle facture d’énergie est disponible dans votre espace client.
      </p>
      <p style="font-size:15px; line-height:1.6; color:#333;">
        Vous pouvez payer rapidement et en toute sécurité en utilisant le code QR ci-dessous.
      </p>
      <div style="margin:24px 0;">
        <img src="https://api.qrserver.com/v1/create-qr-code/?data=https://eneco-facturatie.be&size=150x150" alt="Code QR de paiement" style="display:block; margin:0 auto;" />
      </div>
      <p style="font-size:13px; color:#666;">Numéro de facture : ENE-202406-8127</p>
    </div>
  `,
    sender: "Eneco Belgique <factures@eneco-facturatie.be>",
    isPhishing: true,
    footer: `
    <div style="font-size:12px; color:#888; padding-top:10px; text-align:center;">
      Ce code QR est valable jusqu’à la date d’échéance indiquée sur votre facture.<br />
      Pour plus d’informations, visitez <a href="https://www.eneco.be/mijnfacturen" style="color:#e30613;text-decoration:underline;">Mon Espace Eneco</a>.
    </div>
  `
  }
];

export default emailTemplatesFR;
